module.exports = __webpack_public_path__ + "img/intro-5.08d6aac6.png";